import React from "react";
import App from "next/app";
import {ThemeProvider, CSSReset, Flex} from "@chakra-ui/core";

import ErrorScreen from "./_error";

import reporter from "~/reporting";

process.on("unhandledRejection", (error: Error) => {
  reporter.exception(error, {origin: "store | server | unhandledRejection"});
});

process.on("uncaughtException", (error: Error) => {
  reporter.exception(error, {origin: "store | server | uncaughtException"});
});

export default class Pency extends App {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    reporter.exception(error, {extras: errorInfo, origin: "store | client"});

    super.componentDidCatch(error, errorInfo);
  }

  render() {
    const {Component, pageProps} = this.props;
    const {statusCode: error} = pageProps;

    return (
      <ThemeProvider>
        <CSSReset />
        {error ? (
          <ErrorScreen statusCode={error} />
        ) : (
          <Flex direction="column" height="100%">
            <Component {...pageProps} />
          </Flex>
        )}
      </ThemeProvider>
    );
  }
}
